var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-icon", { style: { color: _vm.color }, attrs: { size: 32 } }, [
    _vm._v(_vm._s(_vm.content)),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }